/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.resolveFailed.controllers', [
  'ui.router',
  'acme.common.service.logger'
])

.controller('ResolveFailedController', ['$scope', '$state', 'LoggerService', function($scope, $state, LoggerService) {

    $scope.resolveFailed = {

      model: "",

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'An error has occurred',
          buttonRight: {
            label: 'Go to Events List',
            action: function () {
              $scope.go('application.programs.list');
            }
          }
        });
        this.model = LoggerService.errors(true, true);
      },

      complete: function() {},

      success: {
        init: function(response) {},
        complete: function(response) {}
      },

      error: {
        init: function(response) {},
        complete: function(response) {}
      }

    };

    $scope.resolveFailed.init();

}]);